const gtmPusher = (gtmObj, productArr) => {
  let mappedProducts = [];
  const customizations = [];
  if (productArr && productArr.length > 0) {
    mappedProducts = productArr.map(product => {
      if (product.sublines && product.sublines.length > 0) {
        product.sublines.forEach(subline => {
          const customization = {
            id: '',
            name: subline?.product,
            quantity: subline?.quantity || 1,
            price: subline?.line_total,
            brand: 'N/A',
            category: 'add on',
            dimension10: 'N/A',
            variant: subline?.variant || 'N/A',
            list: gtmObj?.list,
            position: 0,
            os: window?.navigator?.platform,
          };
          customizations.push(customization);
        });
      }

      const extraValues = {};
      if (window?.navigator?.platform !== undefined)
        extraValues.os = window?.navigator?.platform;

      return {
        id: product.product_id || null,
        name: product.product || null,
        quantity: Number(product.quantity) || null,
        price: product.unit_net
          ? product.unit_net
          : product.prices?.recommended_retail_price || null,
        brand: product.attributes?.item_type
          ? product.attributes?.brand || null
          : null,
        category: product.attributes?.item_type
          ? product.attributes?.item_type
          : null,
        dimension10: product.attributes?.team || 'No club',
        variant: product.attributes?.color?.join?.(', ') || null,
        list: gtmObj.list || null,
        position: product.position || 0,
        ...extraValues
      };
    });

    mappedProducts = gtmObj.eventLabel === 'add on' ? [...customizations] : [...mappedProducts, ...customizations];
  }

  const pushObj = {
    event: gtmObj.event,
    eventAction: gtmObj.eventAction,
    eventCategory: gtmObj.eventCategory || 'ecommerce',
    eventLabel: gtmObj.eventLabel,
    eventNonInteraction: gtmObj.eventNonInteraction || false,
    eventValue: gtmObj.eventValue || 0,
    pageType: window?.pageType || gtmObj.pageType || null,
    virtualPath: gtmObj.virtualPath || null
  };

  if (gtmObj.event === 'productDetailView') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      detail: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
  }

  if (gtmObj.event === 'addToCart') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      add: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
    const copyObj = JSON.parse(JSON.stringify(pushObj));
    copyObj.event = 'cartUpdate';
    copyObj.ecommerce.action = 'item_added';
    if (gtmObj.currentCart !== undefined) {
      copyObj.ecommerce.add.currentCart = gtmObj.currentCart;
    }
    const objectsArray = [].concat(pushObj, copyObj);
    if (window.dataLayer) return window.dataLayer.push(...objectsArray);
  }

  if (gtmObj.event === 'removeFromCart') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      remove: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
    const copyObj = JSON.parse(JSON.stringify(pushObj));
    copyObj.event = 'cartUpdate';
    copyObj.ecommerce.action = 'item_removed';
    if (gtmObj.currentCart !== undefined) {
      copyObj.ecommerce.remove.currentCart = gtmObj.currentCart;
    }
    const objectsArray = [].concat(pushObj, copyObj);
    if (window.dataLayer) return window.dataLayer.push(...objectsArray);
  }

  if (gtmObj.event === 'checkout') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      checkout: {
        actionField: {
          step: gtmObj.step, // ex.1
          option: gtmObj.option || '' // ex.'MobilePay'
        },
        products: mappedProducts
      }
    };
  }

  if (gtmObj.event === 'purchase') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      purchase: {
        actionField: {
          id: gtmObj.orderId || '',
          revenue: gtmObj.revenue,
          shipping: gtmObj.shipping,
          tax: gtmObj.tax,
          coupon: gtmObj.coupon,
          cartTotalAmount: gtmObj.cartTotalAmount
        },
        products: mappedProducts
      },
      address: {
        name: gtmObj.name,
        company: gtmObj.company,
        address: gtmObj.address,
        address2: gtmObj.address2,
        postcode: gtmObj.postcode,
        town: gtmObj.town,
        country: gtmObj.country,
        phoneNumber: gtmObj.phoneNumber,
        email: gtmObj.email
      }
    };
  }

  if (gtmObj.event === 'cartState') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      cartState: {
        products: mappedProducts
      }
    };
  }

  if (window.dataLayer) return window.dataLayer.push(pushObj);
  return false;
};

export default gtmPusher;
